module.exports = __webpack_public_path__ + "6d1558adf23f2d1fc311681ac881838d.svg";